import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import MediaCollectionItem from "../media-collection-item"
import { mobileIs } from "../../../utils/siteUtils";

const MediaCollectionRows = props => {
  const { row } = props
	const id = props.id
	const [loadedItem,setLoadedItem] = useState({})
	const [rootWidth,setRootWidth] = useState('auto')
  const isMobile = mobileIs();

	const showModel = (id, itemIndex) => {
		if(row.items[itemIndex].fields.models){
			props.showModel(id)
		}
	}
	const handleOnLoaded = (id,width) => {
		let newData = loadedItem;
		newData[id] = id;
		setLoadedItem(newData);
		if( Object.keys(loadedItem).length == row.items.length ){
			props.handleOnLoaded(id)
			if(!isMobile && row.items.length>1)setRootWidth(width+'px')
		}
	}
  return (
		<>
			{ row && row.items.map((item,itemIndex)=>(
				<div className="c-media-collection__rows-item" style={{height: rootWidth}} key={itemIndex} onClick={v=>{showModel(item.id,itemIndex)}}>
					<MediaCollectionItem data={item.fields} id={item.id} handleOnLoaded={handleOnLoaded} />
					<div className="mask"></div>
				</div>
			))}
		</>
  )
};
export default MediaCollectionRows;
